export const API_GET_ALL_BOX_LIVE = 'API_GET_ALL_BOX_LIVE';
export const API_GET_ALL_BOX_LIVE_SUCCESS = 'API_GET_ALL_BOX_LIVE_SUCCESS';
export const API_GET_ALL_BOX_LIVE_FAIL = 'API_GET_ALL_BOX_LIVE_FAIL';


export const API_PUT_BOX_AVAILABLE = 'API_PUT_BOX_AVAILABLE';
export const API_PUT_BOX_AVAILABLE_SUCCESS = 'API_PUT_BOX_AVAILABLE_SUCCESS';
export const API_PUT_BOX_AVAILABLE_FAIL = 'API_PUT_BOX_AVAILABLE_FAIL';

export const API_PUT_BOX_BUSY = 'API_PUT_BOX_BUSY';
export const API_PUT_BOX_BUSY_SUCCESS = 'API_PUT_BOX_BUSY_SUCCESS';
export const API_PUT_BOX_BUSY_FAIL = 'API_PUT_BOX_BUSY_FAIL';

export const API_GET_MY_BOX_STATUS = 'API_GET_MY_BOX_STATUS'
export const API_GET_MY_BOX_STATUS_SUCCESS = 'API_GET_MY_BOX_STATUS_SUCCESS'
export const API_GET_MY_BOX_STATUS_FAIL = 'API_GET_MY_BOX_STATUS_FAIL'